import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import getSafeRedirectUrl from './getSafeRedirectUrl';

function Redirect() {
  const [params] = useSearchParams();
  const to = params.get('to');

  const sanitizedTo = useMemo(() => getSafeRedirectUrl(to), [to]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.href = sanitizedTo;
    }, 4000);

    return () => clearTimeout(timeout);
  }, [sanitizedTo]);

  return (
    <div style={{ color: 'black', margin: '20px' }}>
      You'll be redirected to <a href={sanitizedTo}>{sanitizedTo}</a> shortly.
    </div>
  );
}

export default Redirect;
